export type Placement = {
  id: string;
  name: string;
  summary: string;
  detailTitle: string;
  details: { label: string; text: string }[];
  note?: string;
};

export const placements: Placement[] = [
  {
    id: "scpi",
    name: "SCPI",
    summary:
      "Une SCPI (Société Civile de Placement Immobilier) permet d'investir dans l'immobilier sans gérer directement un bien. Vous percevez des revenus réguliers issus des loyers, avec un ticket d'entrée réduit et une gestion entièrement déléguée.",
    detailTitle: "Les types de SCPI",
    details: [
      { label: "Rendement", text: "Axées sur la distribution de revenus réguliers." },
      { label: "Fiscales", text: "Des avantages fiscaux en contrepartie d'un engagement de détention." },
      { label: "Plus-value", text: "Une valorisation du capital sur le long terme." },
    ],
    note: "Capital non garanti, variation des loyers et des prix de l'immobilier : à envisager sur le long terme.",
  },
  {
    id: "structures",
    name: "Produits structurés",
    summary:
      "Un instrument combinant plusieurs actifs (actions, obligations, dérivés) pour offrir un rendement ajusté à un niveau de risque : protection du capital, optimisation du rendement ou exposition à un marché spécifique.",
    detailTitle: "Les types de produits structurés",
    details: [
      { label: "Capital garanti", text: "Remboursement du capital initial à l'échéance, gains limités." },
      { label: "Capital protégé", text: "Protection partielle avec un rendement plus attractif." },
      { label: "Effet de levier", text: "Amplifie les gains potentiels mais aussi les pertes." },
      { label: "Autocall", text: "Remboursement anticipé si certaines conditions sont remplies." },
    ],
  },
  {
    id: "assurance-vie",
    name: "Assurance vie",
    summary:
      "Un placement pour épargner sur le long terme dans un cadre fiscal avantageux. Idéal pour préparer un projet, optimiser la transmission de patrimoine ou compléter ses revenus à la retraite.",
    detailTitle: "Les supports d'investissement",
    details: [
      { label: "Fonds en euros", text: "Sécurisés, capital garanti et intérêts annuels." },
      { label: "Unités de compte", text: "Actions, obligations, SCPI : rendement potentiel plus élevé, capital non garanti." },
    ],
  },
];

export const otherPlacements = ["Loi Girardin", "Contrat de capitalisation", "PER individuel"];
